module.exports = __webpack_public_path__ + "img/ic_mail.49eda98d.svg";